import { render, staticRenderFns } from "./RewardManagement.vue?vue&type=template&id=5e5e5522&scoped=true&"
import script from "./RewardManagement.vue?vue&type=script&lang=js&"
export * from "./RewardManagement.vue?vue&type=script&lang=js&"
import style0 from "./RewardManagement.vue?vue&type=style&index=0&id=5e5e5522&lang=less&scoped=true&"
import style1 from "./RewardManagement.vue?vue&type=style&index=1&id=5e5e5522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5e5522",
  null
  
)

export default component.exports